import React from 'react';
import styles from './Typography.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

export function Heading({
  level = 2,
  children,
  tone = 'light',
  className,
  as,
  ...rest
}) {
  const Tag = as || `h${level}`;
  return (
    <Tag
      className={clsx(
        styles.heading,
        styles[`h${level}`],
        tone === 'dark' && styles.onDark,
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function Text({
  children,
  size = 'base',
  variant = 'default',
  tone = 'light',
  as: Tag = 'p',
  className,
  ...rest
}) {
  return (
    <Tag
      className={clsx(
        styles.text,
        styles[`size-${size}`],
        variant !== 'default' && styles[variant],
        tone === 'dark' && styles.onDark,
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function Label({ children, tone = 'light', as, className, ...rest }) {
  // a Label for a field (`htmlFor`) is a real <label>, so the field is named
  // by it; as a span, `htmlFor` did nothing and the field went unnamed
  const Tag = as ?? (rest.htmlFor ? 'label' : 'span');
  return (
    <Tag
      className={clsx(
        styles.label,
        tone === 'dark' && styles.onDark,
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}
